// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { tap, map, filter } from 'rxjs/operators';
import { LoggerUserReducer } from '.';

@Injectable({ providedIn: 'root' })
export class LoggedUserFacadeService {
  loggedUser$: any;
  constructor(private store: Store<any>) {
    this.loggedUser$ = this.store.select('loggedUser').pipe(
      filter(state => state && !!state.data),
      map((state: LoggerUserReducer) => state.data)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/state/logged-user/logged-user.facade.ts